import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";
import ContactUs from "pages/LandingPages/ContactUs";
import Services from "pages/LandingPages/Services";
import Maximizee from "pages/LandingPages/Services/components/pages/Maximizee";
import Crane from "pages/LandingPages/Services/components/pages/Crane";
import Intellisenz from "pages/LandingPages/Services/components/pages/Intellisenz";
import GreenBOS from "pages/LandingPages/Services/components/pages/GreenBOS";
import Monitoring from "pages/LandingPages/Services/components/pages/monitoring";
import IotPage from "pages/LandingPages/Services/components/pages/iotPage";
import VisionMission from "layouts/pages/landing-pages/ManagementTeam";
import OurCoreValues from "layouts/pages/landing-pages/OurCoreValues";
import ChillerOptimizationSystem from "layouts/pages/landing-pages/ChillerOptimizationSystem/ChillerOptimizationSystem";
import AboutUS from "pages/LandingPages/AboutUs";
import OurPartner from "pages/LandingPages/Partner";
import CaseStudies from "pages/LandingPages/CaseStudies";
import GreenBOSLandingPage from "layouts/pages/landing-pages/GreenbosLandingPage/page2";
import MallsGreenBOS from "layouts/pages/landing-pages/MallsGreenBOS/greenbos";
import routes from "routes";
import ChillerLandingPage from "layouts/pages/landing-pages/maximizee/ChillerLandingPage";
import MallsLandingPage from "layouts/pages/landing-pages/MallsLandingPage/malls";
import MallsMaximizee from "layouts/pages/landing-pages/MallsMaximizee/MallsMaximizee";
import Career from "layouts/pages/landing-pages/career-page/CareerPage";
import ChargemanCareer from "layouts/pages/landing-pages/career-chargeman/Chargeman";
import SavingsCalculator from "layouts/pages/landing-pages/savingscalculator/SavingsCalculator";
import CareerMain from "layouts/pages/landing-pages/CareerMain/CareerMain";
import CPForm from "layouts/pages/landing-pages/career-page/CPForm";
import Software from "layouts/pages/landing-pages/career-page/SoftwareWrapper";
// Global Chatbot & WhatsApp imports
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import { FaRobot } from "react-icons/fa";
import config from "config.js";
import MessageParser from "chatbot/MessageParser.js";
import ActionProvider from "chatbot/ActionProvider.js";
import WhatsappChat from "whatsapp/WhatsappChat.js";
import MKBox from "components/MKBox";

export default function App() {
  const { pathname } = useLocation();

  // Initialize Google Analytics
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-B0CTC4016F";
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-B0CTC4016F");
  }, []);

  // Reset scroll on route change
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route, index) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.route || index} />;
      }
      return null;
    });

  // Global chatbot state
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const toggleChatbot = () => setIsChatbotOpen((prev) => !prev);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/VisionMission" element={<VisionMission />} />
        <Route path="/ChillerOptimizationSystem" element={<ChillerOptimizationSystem />} />
        <Route path="/OurCoreValues" element={<OurCoreValues />} />
        <Route path="/Maximizee" element={<Maximizee />} />
        <Route path="/Crane" element={<Crane />} />
        <Route path="/Intellisenz" element={<Intellisenz />} />
        <Route path="/GreenBOS" element={<GreenBOS />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/iotPage" element={<IotPage />} />
        <Route path="/AboutUS" element={<AboutUS />} />
        <Route path="/ourPartner" element={<OurPartner />} />
        <Route path="/caseStudies" element={<CaseStudies />} />
        <Route path="/greenbos-building-sustainability" element={<GreenBOSLandingPage />} />
        <Route path="/maximizee-chiller-optimization" element={<ChillerLandingPage />} />
        <Route path="/malls-sustainability-solutions" element={<MallsLandingPage />} />
        <Route path="/malls-chiller-optimization" element={<MallsMaximizee />} />
        <Route path="/malls-greenbos-sustainability" element={<MallsGreenBOS />} />
        <Route path="/careers" element={<CareerMain />} />
        <Route path="/career-dataanalyst" element={<Career />} />
        <Route path="/career-chargeman" element={<ChargemanCareer />} />
        <Route path="/savings-calculator" element={<SavingsCalculator />} />
        <Route path="/career-form" element={<CPForm />} />
        <Route path="/career-softwaredeveloper" element={<Software />} />
        <Route path="*" element={<Navigate to="/presentation" />} />
      </Routes>

      {/* Global Chatbot */}
      {isChatbotOpen && (
        <div
          id="chatbot-container"
          style={{
            position: "fixed",
            bottom: "80px",
            left: "20px",
            zIndex: 1000,
            backgroundColor: "white",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
          />
        </div>
      )}

      {/* Chatbot Toggle Button */}
      <MKBox
        sx={{
          position: "fixed",
          bottom: 20,
          left: 20,
          zIndex: 1000,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "50px",
          height: "50px",
          backgroundColor: "#007BFF",
          borderRadius: "50%",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.2s ease-in-out",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
        onClick={toggleChatbot}
      >
        <FaRobot color="white" size="24px" />
      </MKBox>

      {/* Global WhatsApp Widget */}
      <WhatsappChat />
    </ThemeProvider>
  );
}
